import React, { useEffect, useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";
import handGesture from "../assets/hand-gesture.png";
import { useNavigate } from "react-router-dom";

const categories = [
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
  { name: "ICAN", dateCreated: "09 May, 2024" },
];

const isCompanySettingsRoute = () =>
  typeof window !== "undefined" && window.location.pathname.startsWith("/company-settings");

export const Modal = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const compactClassName = isCompanySettingsRoute() ? "modal-compact" : "";

  const handleBackdropClick = () => {
    onClose();
  };

  const handleContentClick = (e) => {
    e.stopPropagation(); // Prevent backdrop click event from firing
  };

  return (
    <div
      onClick={handleBackdropClick}
      role="presentation"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div
        onClick={handleContentClick}
        role="dialog"
        aria-modal="true"
        className={`bg-white rounded-lg shadow-lg p-5 w-full max-w-[520px] max-h-[70vh] overflow-y-auto mx-4 ${compactClassName}`}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close dialog"
          className="text-[30px] text-[#758E95] hover:text-gray-900 float-right modal-close"
        >
          &times;
        </button>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};

export const InviteModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const compactClassName = isCompanySettingsRoute() ? "modal-compact" : "";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className={`bg-white rounded-lg shadow-md p-5 w-full max-w-[560px] max-h-[70vh] overflow-y-auto mx-4 ${compactClassName}`}
      >
        <button
          onClick={onClose}
          className="text-[30px] text-[#758E95] hover:text-gray-900 float-right modal-close"
        >
          &times;
        </button>

        <div className="mt-4">
          {/* Render-prop pattern: pass helpers into children */}
          {typeof children === "function" ? children({ onClose }) : children}
        </div>
      </div>
    </div>
  );
};

export const ImageModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  const compactClassName = isCompanySettingsRoute() ? "modal-compact" : "";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className={`bg-white rounded-lg shadow-lg p-5 w-full max-w-[640px] max-h-[75vh] overflow-y-auto mx-4 ${compactClassName}`}
      >
        <button
          onClick={onClose}
          className="text-[30px] text-[#758E95] hover:text-gray-900 float-right modal-close"
        >
          &times;
        </button>
        <div className="mt-4">{children}</div>
      </div>
    </div>
  );
};

export function SuccessModal({
  isOpen,
  onClose,
  onDone,
  doneLabel = "Done",
  children,
  modalClassName = "",
  bodyClassName = "",
  actionsClassName = "",
}) {
  if (!isOpen) return null;

  const handleDone = () => {
    if (typeof onDone === "function") {
      onDone();
      return;
    }

    onClose?.();
  };

  return (
    <div className="fixed inset-0 z-50 font-Outfit flex items-center justify-center bg-black bg-opacity-50">
      <div className={`bg-white rounded-lg shadow-lg p-6 w-[400px] h-[400px] flex flex-col ${modalClassName}`}>
        <button
          onClick={onClose}
          className="text-[30px] text-[#758E95] hover:text-gray-900 self-end"
        >
          &times;
        </button>
        <div className={`mt-10 ${bodyClassName}`}>
          {children ? (
            <div>{children}</div>
          ) : (
            <>
              <div className=" flex justify-center items-center">
                <img
                  className="w-24 h-24"
                  src={handGesture}
                  alt=""
                />
              </div>

              <div>
                <h2 className="text-black text-center text-3xl leading-[27px] font-bold mb-2">
                  Success
                </h2>
              </div>
              <p className="text-black text-center text-lg leading-[18.9px]">
                Your submission was made <br /> successfully.
              </p>
            </>
          )}

          <div className={`flex justify-center mt-10 items-center ${actionsClassName}`}>
            <button
              onClick={handleDone}
              className=" text-white rounded-xl hover:bg-[#334cba] w-48 h-12 bg-[#1234CD] "
            >
              {doneLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export function DeleteItem({ isOpen, onClose, children }) {
  if (!isOpen) return null;
  const handleBackdropClick = () => {
    onClose();
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };
  return (
    <>
      <div
        onClick={handleBackdropClick}
        className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black bg-opacity-50 p-4"
      >
        <div
          onClick={handleContentClick}
          role="dialog"
          aria-modal="true"
          className="flex max-h-[calc(100vh-2rem)] w-full max-w-sm flex-col overflow-y-auto rounded-xl bg-white p-5 shadow-xl sm:p-6"
        >
          <button
            type="button"
            onClick={onClose}
            aria-label="Close confirmation dialog"
            className="self-end text-[30px] leading-none text-[#758E95] hover:text-gray-900"
          >
            &times;
          </button>
          {children}
        </div>
      </div>
    </>
  );
}

export function SuccessfulDelete({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  const handleBackdropClick = () => {
    onClose();
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  return (
    <div
      onClick={handleBackdropClick}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div
        onClick={handleContentClick}
        className="bg-white rounded-lg shadow-lg p-6 w-[256px] h-[264px] flex flex-col "
      >
        <button
          onClick={onClose}
          className="text-[30px] text-[#758E95] hover:text-gray-900 self-end"
        >
          &times;
        </button>

        {children}
      </div>
    </div>
  );
}

export function AddCategory({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-[525px]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[20px] font-bold text-[#400167] font-satoshi mt-4">
            Create Category
          </h2>
          <button
            onClick={onClose}
            className="text-[25px] text-[#758E95] hover:text-gray-900 relative right-0 -top-3 mb-6"
          >
            &times;
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function Category({ title, isOpen, onClose, children }) {
  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-4 rounded-lg shadow-lg w-[384px] h-[334px]">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-[20px] font-bold text-[#400167] font-satoshi mt-4">
              {title}
            </h2>
            <button
              onClick={onClose}
              className="text-[25px] text-[#758E95] hover:text-gray-900 relative right-0 -top-3 mb-6"
            >
              &times;
            </button>
          </div>
          {children}
        </div>
      </div>
    </>
  );
}

export function BranchModal({ open, onClose, branch }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !branch) return null;

  const status = String(branch.status || "")
    .trim()
    .toLowerCase();
  const isActive = status === "active";

  return (
    // overlay
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      aria-modal="true"
      role="dialog"
      aria-labelledby="branch-modal-title"
    >
      {/* modal box */}
      <div className="relative w-full max-w-2xl rounded-md bg-white p-8 shadow-lg mx-4">
        {/* header */}
        <div className="flex items-start justify-between">
          <h2
            id="branch-modal-title"
            className="text-2xl font-semibold"
          >
            Branch Details
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-gray-600 hover:text-gray-900 ml-4"
          >
            <span className="text-2xl leading-none">×</span>
          </button>
        </div>

        {/* body */}
        <div className="mt-6 space-y-6">
          <div>
            <p className="font-semibold">
              Branch Name: <span className="font-normal">{branch.name}</span>
            </p>
          </div>

          <div>
            <p className="font-semibold">
              Branch Address:{" "}
              <span className="font-normal">{branch.address}</span>
            </p>
          </div>

          <div>
            <p className="font-semibold mb-3">Branch Status</p>

            {/* status radios (disabled, read-only visuals) */}
            <div className="space-y-3">
              <label className="flex items-center space-x-3 text-base">
                <input
                  type="radio"
                  name="branch-status"
                  checked={isActive}
                  readOnly
                  className="form-radio h-4 w-4 text-indigo-600 border-gray-300"
                />
                <span className="ml-2 text-sm">Active</span>
              </label>

              <label className="flex items-center space-x-3 text-base">
                <input
                  type="radio"
                  name="branch-status"
                  checked={!isActive}
                  readOnly
                  className="form-radio h-4 w-4 text-indigo-600 border-gray-300"
                />
                <span className="ml-2 text-sm">Inactive</span>
              </label>
            </div>

            {/* extra context depending on state */}
            <div className="mt-4 text-sm">
              {isActive ? (
                <p className="text-gray-700">
                  This branch is currently{" "}
                  <span className="font-semibold text-green-600">Active</span>.
                  Customers and staff can access services at this location.
                </p>
              ) : (
                <p className="text-gray-700">
                  This branch is currently{" "}
                  <span className="font-semibold text-red-600">Inactive</span>.
                  It is not available for use until activated.
                </p>
              )}
            </div>
          </div>

          {/* optional description */}
          {branch.description && (
            <div>
              <p className="font-semibold mb-1">Description</p>
              <p className="text-sm text-gray-700">{branch.description}</p>
            </div>
          )}
        </div>

        {/* footer */}
        <div className="mt-8 flex justify-center">
          <button
            onClick={onClose}
            className="rounded-full bg-blue-600 px-10 py-3 text-white text-lg font-medium hover:bg-blue-700"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}

export function LessonsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-[256px]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[20px] font-bold text-[#400167] font-satoshi mt-4">
            Choose Lesson
          </h2>
          <button
            onClick={onClose}
            className="text-[25px] text-[#758E95] hover:text-gray-900 relative right-0 -top-3 mb-6"
          >
            &times;
          </button>
        </div>
        <ul>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Lesson Name
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Lesson Name
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Lesson Name
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Lesson Name
          </li>
        </ul>
      </div>
    </div>
  );
}

export function ExamsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-[256px]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[20px] font-bold text-[#400167] font-satoshi mt-4">
            Choose Exam
          </h2>
          <button
            onClick={onClose}
            className="text-[25px] text-[#758E95] hover:text-gray-900 relative right-0 -top-3 mb-6"
          >
            &times;
          </button>
        </div>
        <ul>
          <li className="underline text-[#010811] text-[14px] mb-3">
            SSCE Exams
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Cambridge & A-Level
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            JAMB & POST UTME
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            ICAN Certification
          </li>
        </ul>
      </div>
    </div>
  );
}

export function ClassroomsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-[256px]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[20px] font-bold text-[#400167] font-satoshi mt-4">
            Choose Classroom
          </h2>
          <button
            onClick={onClose}
            className="text-[25px] text-[#758E95] hover:text-gray-900 relative right-0 mb-6 -top-3"
          >
            &times;
          </button>
        </div>
        <ul>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Classroom Name
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Classroom Name
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Classroom Name
          </li>
          <li className="underline text-[#010811] text-[14px] mb-3">
            Classroom Name
          </li>
        </ul>
      </div>
    </div>
  );
}

export function AddClassroom({ isOpen, onClose, children }) {
  if (!isOpen) return null;
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-8 rounded-lg shadow-lg w-[525px]">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-[20px] font-bold text-[#400167] font-satoshi mt-4">
              Add Classroom
            </h2>
            <button
              onClick={onClose}
              className="text-[30px] text-[#758E95] hover:text-gray-900 relative right-0 mb-6 -top-3"
            >
              &times;
            </button>
          </div>

          {children}
        </div>
      </div>
    </>
  );
}

export function FolderContextModal({
  isOpen,
  onClose,
  position,
  onRename,
  folderName,
}) {
  const modalRef = useRef(null);
  const navigate = useNavigate();
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [newName, setNewName] = useState(folderName);

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const menuItems = [
    { label: "Open", path: `/resources/open-folder` },
    // { label: "Rename", path: `/folders/${folderName}/rename` },
    // {
    //   label: "Rename",
    //   onClick: () => setShowRenameModal(true), // OPEN MODAL
    // },
    {
      label: "Rename",
      onClick: () => onRename(folderName), // call parent function to open modal
    },

    { label: "Add file", path: `/folders/${folderName}/add-file` },
    { label: "Share", path: `/folders/${folderName}/share` },
    { label: "Collaborators", path: `/folders/${folderName}/collaborators` },
    { label: "Details", path: `/folders/${folderName}/details` },
    { label: "Remove", path: `/folders/${folderName}/remove`, isDelete: true },
  ];

  const handleRename = () => {
    console.log("Renamed to:", newName);
    // put your update logic here (API call or state update)
    setShowRenameModal(false);
  };

  // const menuItems = [
  //   {
  //     label: "Open",
  //     action: () => navigate(`/folders/${folderName}`),
  //   },
  //   {
  //     label: "Rename",
  //     action: () => console.log("Rename folder:", folderName),
  //   },
  //   {
  //     label: "Add file",
  //     action: () => console.log("Add file to:", folderName),
  //   },
  //   { label: "Share", action: () => console.log("Share folder:", folderName) },
  //   {
  //     label: "Collaborators",
  //     action: () => console.log("Collaborators:", folderName),
  //   },
  //   { label: "Details", action: () => console.log("Details:", folderName) },
  //   {
  //     label: "Remove",
  //     action: () => console.log("Remove folder:", folderName),
  //     isDelete: true,
  //   },
  // ];

  return (
    <div>
      <div
        ref={modalRef}
        className="fixed bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50 min-w-48"
        style={{
          left: position.x,
          top: position.y,
        }}
      >
        {menuItems.map((item, index) => (
          <button
            key={index}
            onClick={() => {
              navigate(item.path);
              onClose();
            }}
            className={`w-full flex items-center gap-3 px-4 py-2 text-sm hover:bg-gray-50 transition-colors ${
              item.isDelete
                ? "text-red-600 hover:text-red-700"
                : "text-gray-700 hover:text-gray-900"
            }`}
          >
            <span>{item.label}</span>
          </button>
        ))}
      </div>

      {/* RENAME MODAL */}
      {showRenameModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white w-80 p-6 rounded-lg shadow-lg">
            <h2 className="text-lg font-semibold mb-3">Rename Folder</h2>

            <input
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              className="w-full border px-3 py-2 rounded mb-4"
              placeholder="Enter new folder name"
            />

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowRenameModal(false)}
                className="px-4 py-2 rounded bg-gray-200 text-gray-700"
              >
                Cancel
              </button>

              <button
                onClick={handleRename}
                className="px-4 py-2 rounded bg-blue-600 text-white"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// export function FolderContextModalDemo() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [folderName, setFolderName] = useState("My Folder");

//   const [showRenameModal, setShowRenameModal] = useState(false);
//   const [renameValue, setRenameValue] = useState(folderName);

//   // Open main folder menu modal
//   const openFolderModal = () => setIsModalOpen(true);
//   const closeFolderModal = () => setIsModalOpen(false);

//   // Handle Rename click
//   const handleRenameClick = () => {
//     setRenameValue(folderName); // set current folder name
//     setShowRenameModal(true); // show rename modal
//   };

//   // Handle saving rename
//   const handleSaveRename = () => {
//     setFolderName(renameValue);
//     setShowRenameModal(false);
//     setIsModalOpen(false); // optional: close main menu after rename
//     console.log("Folder renamed to:", renameValue);
//   };

//   // Menu items
//   const menuItems = [
//     { label: "Open", onClick: () => console.log("Open clicked") },
//     { label: "Rename", onClick: handleRenameClick },
//     { label: "Add file", onClick: () => console.log("Add file clicked") },
//     { label: "Share", onClick: () => console.log("Share clicked") },
//     {
//       label: "Collaborators",
//       onClick: () => console.log("Collaborators clicked"),
//     },
//     { label: "Details", onClick: () => console.log("Details clicked") },
//     {
//       label: "Remove",
//       onClick: () => console.log("Remove clicked"),
//       isDelete: true,
//     },
//   ];

//   return (
//     <>
//       {/* Trigger button */}
//       <button
//         onClick={openFolderModal}
//         className="px-4 py-2 bg-blue-600 text-white rounded"
//       >
//         Open Folder Menu
//       </button>

//       {/* Main Folder Menu Modal */}
//       {isModalOpen && (
//         <div
//           className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
//           onClick={closeFolderModal}
//         >
//           <div
//             className="bg-white rounded-lg shadow-lg w-48 p-2"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {menuItems.map((item, idx) => (
//               <button
//                 key={idx}
//                 onClick={item.onClick}
//                 className={`block w-full text-left px-4 py-2 hover:bg-gray-100 ${
//                   item.isDelete ? "text-red-600" : "text-gray-800"
//                 }`}
//               >
//                 {item.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Rename Modal inside the same component */}
//       {showRenameModal && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[999]">
//           <div className="bg-white rounded-lg shadow-lg w-80 p-6">
//             <h2 className="text-lg font-semibold mb-4">Rename Folder</h2>
//             <input
//               type="text"
//               value={renameValue}
//               onChange={(e) => setRenameValue(e.target.value)}
//               className="w-full border px-3 py-2 rounded mb-4"
//             />
//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => setShowRenameModal(false)}
//                 className="px-4 py-2 rounded bg-gray-200"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleSaveRename}
//                 className="px-4 py-2 rounded bg-blue-600 text-white"
//               >
//                 Save
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

export default function EditTimeModal({ isOpen, onClose }) {
  const [duration, setDuration] = useState("7:00:00");
  const [startTime, setStartTime] = useState("09:00");
  const [endTime, setEndTime] = useState("16:00");
  const [description, setDescription] = useState("");
  const [tag, setTag] = useState("");

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-50">
      <div className="bg-white rounded-lg shadow-lg w-[420px] p-6 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-black"
        >
          <FaTimes />
        </button>

        {/* Title */}
        <h2 className="text-lg font-semibold mb-2">Edit Time</h2>
        <p className="text-sm text-black">18/04/2024</p>
        <p className="font-medium mb-4">Design a Wireframe for App</p>

        {/* Time Inputs */}
        <div className="flex items-center gap-3 mb-4">
          <input
            type="text"
            value={duration}
            onChange={(e) => setDuration(e.target.value)}
            className="border border-purple-500 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 w-[100px]"
          />
          <input
            type="time"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            className="border rounded-md px-3 py-2 text-sm w-[100px]"
          />
          <span className="text-gray-600">to</span>
          <input
            type="time"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            className="border rounded-md px-3 py-2 text-sm w-[100px]"
          />
        </div>

        {/* Description */}
        <div className="mb-4">
          <label className="block text-sm mb-1">Description</label>
          <select
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="border rounded-md w-full px-3 py-2 text-sm"
          >
            <option value="">Title</option>
            <option value="UI Work">UI Work</option>
            <option value="Testing">Testing</option>
          </select>
        </div>

        {/* Tags */}
        <div className="mb-6">
          <label className="block text-sm mb-1">Select tags</label>
          <select
            value={tag}
            onChange={(e) => setTag(e.target.value)}
            className="border rounded-md w-full px-3 py-2 text-sm"
          >
            <option value="">Title</option>
            <option value="Frontend">Frontend</option>
            <option value="Backend">Backend</option>
          </select>
        </div>

        <div className="flex justify-around items-center">
          <button
            onClick={onClose}
            className="px-8 py-2 rounded-lg border border-blue-500 text-blue-500 hover:bg-blue-50"
          >
            Cancel
          </button>
          <button className="px-8 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700">
            Update
          </button>
        </div>
      </div>
    </div>
  );
}
